import script from "./GateNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./GateNavbar.vue?vue&type=script&setup=true&lang=js"

import "./GateNavbar.vue?vue&type=style&index=0&id=12e98dd7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e98dd7"]])

export default __exports__